import { makeStyles } from 'tss-react/mui';
import { grey } from '@mui/material/colors';

export const useFindPsychiatristPageStyles = makeStyles()(theme => ({
  bg: {
    backgroundColor: grey[50],
  },
  root: {
    boxSizing: 'border-box',
    margin: '0 auto',
    maxWidth: '792px',
    width: '100%',
    flex: 1,
    paddingBottom: theme.spacing(6),
  },
  header: {
    paddingTop: theme.spacing(3),

    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(3, 2, 0),
    }
  },
  emptyState: {
    backgroundColor: theme.palette.common.white,
    margin: theme.spacing(5, 2, 0),
    padding: theme.spacing(3),

    [theme.breakpoints.up('sm')]: {
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: '4px',
      margin: theme.spacing(5, 0, 0),
    }
  },
}));
